import { render, staticRenderFns } from "./Remarks.vue?vue&type=template&id=72030554&scoped=true&"
import script from "./Remarks.vue?vue&type=script&lang=js&"
export * from "./Remarks.vue?vue&type=script&lang=js&"
import style0 from "./Remarks.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Remarks.vue?vue&type=style&index=1&id=72030554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72030554",
  null
  
)

export default component.exports